import { get } from "@/services/api.services";
import { SavedObject } from "@/services/commonModels";

export type Application = {
    thingInstanceDataId: string;
};

export type SavedApplication = Application &
    SavedObject<string> & {
        experimentId: number;
    };

export const applicationsAPI = {
    fetchApplicationsForExperiment: async (experimentCode: string): Promise<SavedApplication[]> => {
        return get(`/applications/${experimentCode}`);
    },
};
